/* eslint-disable */
import { produce } from "immer";
import {
  MESSAGES_READ_FETCH_START,
  MESSAGES_READ_FETCH_SUCCESS,
  MESSAGES_READ_FETCH_FAILURE,
} from "../actions/types";

const messagesRead = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case MESSAGES_READ_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case MESSAGES_READ_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case MESSAGES_READ_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default messagesRead;
